export async function refreshBatchDetailsAfterSamplePrint({
  fetchBatch,
  updateSamplesList,
}) {
  await Promise.all([fetchBatch(), updateSamplesList()])
}
